// ── AISuggestButton ───────────────────────────────────────────────────────────
import { TEXT_MUTED, FONT_LABEL } from '../../theme';
// Reusable AI-suggestion trigger button with animated gradient text.
// Props:
//   onClick   — function
//   loading   — bool
//   disabled  — bool
//   lang      — 'es' | 'en'
//   label     — optional { es, en } override for button text
// CSS for .ai-suggest-text, .ai-spark, and related animations is injected
// once at the root in App.js — not here.

const DEFAULT_LABEL = { es: 'Sugerir con IA ✨', en: 'Suggest with AI ✨' };
const LOADING_LABEL = { es: 'Sugiriendo…', en: 'Suggesting…' };

export default function AISuggestButton({ onClick, loading, disabled, lang, label }) {
  const l = lang === 'es' ? 'es' : 'en';
  const isDisabled = disabled || loading;
  const btnLabel = loading
    ? LOADING_LABEL[l]
    : (label ? label[l] : DEFAULT_LABEL[l]);

  return (
    <button
      type="button"
      className={!loading && !isDisabled ? 'ai-suggest-btn' : undefined}
      onClick={onClick}
      disabled={isDisabled}
      style={{
        ...FONT_LABEL,
        background: 'none',
        border: 'none',
        boxShadow: 'none',
        padding: 0,
        margin: 0,
        display: 'inline-block',
        cursor: isDisabled ? 'default' : 'pointer',
        opacity: !loading && disabled ? 0.4 : 1,
        transition: 'opacity 0.15s, transform 0.15s',
        letterSpacing: '0.03em',
      }}
    >
      {loading ? (
        <span style={{ color: TEXT_MUTED }}>{btnLabel}</span>
      ) : (
        <span className="ai-suggest-text">{btnLabel}</span>
      )}
    </button>
  );
}
